class TradeInForm extends HTMLElement {
  static observedAttributes = ['data-view'];
  
  constructor() {
    super();
    this.stepNumber = this.querySelector('#trade-in-step-number');
    this.progressBarFill = this.querySelector('.trade-in-progress-bar-fill');
    this.form = /** @type {HTMLFormElement} */ (this.querySelector('form#trade-in-form'));
    this.contactForm = /** @type {HTMLFormElement} */ (this.querySelector('form#trade-in-contact-form'));
    this.confirmSubmitButton = this.querySelector('.trade-in-confirm-submit-button');
    this.productBrandSelect = this.querySelector('#product-brand');
    this.uploadArea = this.querySelector('.trade-in-upload-area');
    this.fileInput = this.uploadArea && this.uploadArea.querySelector('#images');
    this.productModelSelect = this.querySelector('#product-model');
    this.getEstimateButton = this.querySelector('.trade-in-submit-button');
    this.continueButton = this.querySelector('.trade-in-continue-button');
    this.taskId = this.getAttribute('data-task-id');
    this.estimateItems = this.querySelector('.trade-in-estimate-items');
    this.estimateCount = this.querySelector('#trade-in-estimate-count');
    this.estimateTotalValue = this.querySelector('#trade-in-estimate-total');
    this.addAnotherItemButton = this.querySelector('.trade-in-add-another-item-button');
    this.backButton = this.querySelector('.trade-in-back-button');
    this.formErrorMessage = this.querySelector('.trade-in-form-error-message');
    this.collectionHandle = this.getAttribute('data-collection');
  }

  connectedCallback() {
    this.getCollectionData();
  }

  async getCollectionData() {
    this.form.classList.add('loading');

    try {
      const response = await fetch(`https://www.teds.com.au/apps/datajet/task/69952c83e9e1b47c78009859`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          collection_handle: this.collectionHandle,
        }),
      });

      const data = await response.json();
      if (data.variants && data.variants.length > 0) {
        this.products = data.variants;
        this.initProductSelect();
        this.formListeners();
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.form.classList.remove('loading');
    }
  }

  initProductSelect() {
    //remove duplicate brands
    const uniqueBrands = [...new Set(this.products.map(product => product.brand))];
    if (this.products && this.products.length > 0 && this.productBrandSelect) {
      this.productBrandSelect.innerHTML += uniqueBrands.map(brand => `<option value="${brand}">${brand}</option>`).join('');
    }
  }

  attributeChangedCallback(/** @type {string} */ name, /** @type {string} */ oldValue, /** @type {string} */ newValue) {
    console.log(name, oldValue, newValue);
    if (name === 'data-view') {
      if (newValue === "form+equipment" || newValue === "estimate") {
        (/** @type {HTMLButtonElement} */ (this.continueButton)).disabled = false;
      } else {
        (/** @type {HTMLButtonElement} */ (this.continueButton)).disabled = true;
      }

      if (newValue === "form+equipment" || newValue === "estimate" || newValue === "details") {
        (/** @type {HTMLButtonElement} */ (this.backButton)).disabled = false;
      } else {
        (/** @type {HTMLButtonElement} */ (this.backButton)).disabled = true;
      }

      if (newValue === "details") {
        this.stepNumber && (this.stepNumber.textContent = "2");
        /** @type {HTMLDivElement} */ (this.progressBarFill).style.width = "100%";
        /** @type {HTMLButtonElement} */ (this.confirmSubmitButton).disabled = false;
      } else {
        this.stepNumber && (this.stepNumber.textContent = "1");
        /** @type {HTMLDivElement} */ (this.progressBarFill).style.width = "50%";
        /** @type {HTMLButtonElement} */ (this.confirmSubmitButton).disabled = true;
      }
    }
  }

  /**
   * Handles the form listeners.
  */
  formListeners() {
    if (this.form) {
      this.handleProductBrandSelect();
      this.fileUpload();
      this.handleSubmit();
      this.handleAddAnotherItem();
      this.handleBackButton();
      this.handleContinueButton();
    }

    if (this.contactForm) {
      this.handleContactFormSubmit();
    }
  }

  /**
   * Handles the contact form submit event.
  */
  handleContactFormSubmit() {
    if (this.contactForm) {
      this.contactForm.addEventListener('submit', async (/** @type {SubmitEvent} */ e) => {
        e.preventDefault();
        const formData = new FormData(this.contactForm);
        const redirectUrl = this.contactForm.getAttribute("data-redirect-url");

        const items = this.querySelectorAll('trade-in-estimate-item');
        const itemsData = [...items].map((/** @type {TradeInEstimateItem} */ item) => item.formDataObject);
        console.log(itemsData);

        const contactFormData = {
          action: 'submit_contact_form',
          name: formData.get('name')?.toString(),
          email: formData.get('email')?.toString(),
          phone: formData.get('phone')?.toString(),
          business_type: formData.get('business_type')?.toString() === 'yes' ? true : false,
          trade_method: formData.get('trade_method')?.toString(),
          store_location: formData.get('store_location')?.toString(),
          items: itemsData,
        };

        const response = await fetch(`https://www.teds.com.au/apps/datajet/task/${this.taskId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(contactFormData),
        });
        const data = await response.json();
        
        if (data.status === "success") {
          this.contactForm.reset();
          if (redirectUrl && redirectUrl !== '') {
            window.location.href = redirectUrl;
          }
        }

      });
    }
  }

  /**
   * Handles the back button click event.
  */
  handleBackButton() {
    if (this.backButton) {
      this.backButton.addEventListener('click', () => {
        this.setAttribute('data-view', 'estimate');
      });
    }
  }

  /**
   * Handles the continue button click event.
  */
  handleContinueButton() {
    if (this.continueButton) {
      this.continueButton.addEventListener('click', () => {
        this.setAttribute('data-view', 'details');
      });
    }
  }

    handleProductBrandSelect() {
  if (!this.productBrandSelect || !this.productModelSelect) return;

  if (!this.products || this.products.length === 0) return;

  this.productBrandSelect.addEventListener('change', (e) => {
    const vendor = e.target.value;

    // ✅ RESET MODEL FIRST
    this.productModelSelect.innerHTML = `<option value="">Select Model</option>`;
    // this.productModelSelect.disabled = true;

    // If brand is reset → stop here
    if (!vendor) return;

    // const filtered = productsData.filter(
    //   item => item.vendor === vendor
    // );
    const filtered = this.products.filter(
      item => item.brand === vendor
    );


    if (!filtered.length) return;

    let optionsHTML = '';

    filtered.forEach(item => {
      optionsHTML += `
        <option value="${item.variant_id}::${item.variant_title}">
          ${item.product_title}
        </option>
      `;
    });

    this.productModelSelect.innerHTML = `
      <option value="">Select Model</option>
      ${optionsHTML}
    `;

    this.productModelSelect.disabled = false;
  });
}



  /**
   * Handles the form submit event.
  */
  handleSubmit() {
    if (this.form) {
      this.form.addEventListener('submit', async (/** @type {SubmitEvent} */ e) => {
        e.preventDefault();
        const formData = new FormData(this.form);
        let itemId = formData.get('item_id')?.toString();
        let action = 'update';
        if (!itemId || itemId === '') {
          itemId = crypto.randomUUID();
          action = 'add';
        }

        const modelSelect = this.productModelSelect;
        const selectedOption = modelSelect.options[modelSelect.selectedIndex];

        const variantValue = formData.get('product_variant_id')?.toString().split('::');

        const formDataObject = {
          item_id: itemId,

          // BRAND
          brand: formData.get('product_vendor'),

          // MODEL
          product_variant_id: variantValue?.[0],
          product_variant_title: selectedOption?.textContent || variantValue?.[1], // ✅ USE OPTION TEXT

          condition: formData.get('condition'),
          accessories: formData.getAll('accessories[]'),
          additional_details: formData.get('additional_details'),
          images: formData.getAll('images[]')
        };


        console.log(formDataObject);
        
        const {trade_amount_value, error} = await this.handleEstimate(formDataObject);
        if (error) {
          console.error(error);
          this.formErrorMessage && (this.formErrorMessage.innerHTML = `<span>${error}</span>`);
          this.formErrorMessage && (this.formErrorMessage.classList.add('visible'));

          setTimeout(() => {
            this.formErrorMessage && (this.formErrorMessage.classList.remove('visible'));
          }, 5000);
          return;
        }

        this.renderEstimate(formDataObject, trade_amount_value, action);
        this.form.reset();
        /** @type {HTMLInputElement} */ (this.form.querySelector('input[name="item_id"]')).value = '';
        this.productBrandSelect?.dispatchEvent(new Event('change'));
      });
    }
  }

  handleAddAnotherItem() {
    if (this.addAnotherItemButton) {
      this.addAnotherItemButton.addEventListener('click', () => {
        this.setAttribute('data-view', 'form+equipment');
      });
    }
  }

  /**
   * Renders the estimate screen.
   * @param {Object} formDataObject - The form data object.
   * @param {number} trade_amount_value - The trade amount value.
   * @param {string} action - The action to perform.
  */
  async renderEstimate(formDataObject, trade_amount_value, action) {
    const /** @type {any} */ data = formDataObject;
    if (action === 'update') {
      const item = this.querySelector(`trade-in-estimate-item[data-item-id="${data.item_id}"]`);
      if (item) {
        /** @type {TradeInEstimateItem} */ (item).formDataObject = data;
        /** @type {TradeInEstimateItem} */ (item).trade_amount_value = trade_amount_value;
        /** @type {TradeInEstimateItem} */ (item).render();
      }
    } else {
      data && await this.fillItems(data, trade_amount_value);
    }
    this.updateEstimateTotal();
    this.setAttribute('data-view', 'estimate');
  }

  /**
   * Fills the items in the estimate screen.
   * @param {Object} formDataObject - The form data object.
   * @param {number} trade_amount_value - The trade amount value.
  */
  async fillItems(formDataObject, trade_amount_value) {
    const item = new TradeInEstimateItem(formDataObject, trade_amount_value, this.form, this);
    this.estimateItems && (this.estimateItems.appendChild(item));
  }

  /**
   * Updates the estimate total.
  */
  updateEstimateTotal() {
    const itemsNodes = this.querySelectorAll('trade-in-estimate-item');
    if (itemsNodes.length === 0) {
      this.setAttribute('data-view', 'form');
      return;
    }
    this.estimateCount && (this.estimateCount.textContent = itemsNodes.length.toString());
    const itemsValues = [...itemsNodes].map((/** @type {TradeInEstimateItem} */ item) => item?.trade_amount_value);
    const totalTradeAmountValue = itemsValues.reduce((acc, curr) => acc + curr, 0);
    if (this.estimateTotalValue) {
      this.estimateTotalValue.textContent = `$${totalTradeAmountValue || 0}`;
    }
  }

  /**
   * Handles the estimate submission.
   * @param {Object} formDataObject - The form data object.
  */


  async handleEstimate(formDataObject) {
   
    try {
      const URL = `https://www.teds.com.au/apps/datajet/task/${this.taskId}`;
      const response = await fetch(URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formDataObject),
      });
      const data = await response.json();
      
      return data; 

      
    } catch (error) {
      console.error(error);
      return { error: error.message };
    }
  }


  /**
   * Fetches the product variants from the Shopify API.
   * @param {string} productHandle - The handle of the product.
  */
  async fetchProductVariants(productHandle) {
    const response = await fetch(`/products/${productHandle}.json`);
    const data = await response.json();
    const variants = data?.product?.variants?.map((/** @type {any} */ variant) => ({
      id: variant.id,
      title: variant.title,
    }));
    return variants;
  }

  fileUpload() {
    if (this.uploadArea && this.fileInput) {
      const fileInput = /** @type {HTMLInputElement} */ (this.fileInput);
      
      // Click to upload
      this.uploadArea.addEventListener('click', () => {
        fileInput.click();
      });
      
      // Drag and drop
      this.uploadArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        const placeholder = this.uploadArea?.querySelector('.trade-in-upload-placeholder');
        if (placeholder) {
          /** @type {HTMLDivElement} */ (placeholder).style.borderColor = '#FCD900';
        }
      });
      
      this.uploadArea.addEventListener('dragleave', (e) => {
        e.preventDefault();
        const placeholder = this.uploadArea?.querySelector('.trade-in-upload-placeholder');
        if (placeholder) {
          /** @type {HTMLDivElement} */ (placeholder).style.borderColor = '#E0E0E0';
        }
      });
      
      this.uploadArea.addEventListener('drop', (e) => {
        e.preventDefault();
        const dragEvent = /** @type {DragEvent} */ (e);
        const placeholder = this.uploadArea?.querySelector('.trade-in-upload-placeholder');
        if (placeholder) {
          /** @type {HTMLDivElement} */ (placeholder).style.borderColor = '#E0E0E0';
        }
        
        if (dragEvent.dataTransfer?.files?.length) {
          fileInput.files = dragEvent.dataTransfer.files;
          this.updateFileDisplay();
        }
      });
      
      // Update display when files are selected
      fileInput.addEventListener('change', this.updateFileDisplay.bind(this));

      this.updateFileDisplay();
    }
  }

  updateFileDisplay() {
    const placeholder = this.uploadArea?.querySelector('.trade-in-upload-placeholder');
    const fileInput = /** @type {HTMLInputElement} */ (this.fileInput);
    if (fileInput?.files?.length && placeholder) {
      const fileCount = fileInput.files.length;
      placeholder.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="17 8 12 3 7 8"></polyline>
          <line x1="12" y1="3" x2="12" y2="15"></line>
        </svg>
        <p>${fileCount} file${fileCount > 1 ? 's' : ''} selected</p>
        <p class="trade-in-upload-hint">Click to change</p>
      `;
    }
  }
}


class TradeInEstimateItem extends HTMLElement {
  constructor( /** @type {Object} */ formDataObject, /** @type {number} */ trade_amount_value, /** @type {HTMLFormElement} */ form, /** @type {TradeInForm} */ tradeInForm) {
    super();
    this.formDataObject = formDataObject;
    this.form = form;
    this.trade_amount_value = trade_amount_value;
    this.tradeInForm = tradeInForm;
  }

  connectedCallback() {
    this.render();
  }

  disconnectedCallback() {
    console.log("Item removed")
    this.tradeInForm.updateEstimateTotal();
  }
  
  listeners() {
    this.removeElement();
    this.handleEdit();
  }

  removeElement() {
    if (this.removeButton) {
      this.removeButton.addEventListener('click', () => {
        console.log('removing item');
        this.remove();
      });
    }
  }

  handleEdit() {
    if (this.editButton) {
      const /** @type {any} */ data = this.formDataObject;
      this.editButton.addEventListener('click', async () => {
        // /** @type {HTMLSelectElement} */ (this.tradeInForm.productBrandSelect).value = `${data.product_handle}::${data.product_title}`;
        /** @type {HTMLSelectElement} */ this.tradeInForm.productBrandSelect.value = data.brand;

          // this.tradeInForm.productBrandSelect.dispatchEvent(
          //   new CustomEvent('change', {
          //     detail: {
          //       variantValue: `${data.product_variant_id}::${data.product_variant_title}`
          //     }
          //   })
          // );
          this.tradeInForm.productBrandSelect.dispatchEvent(
            new CustomEvent('change', {
              detail: {
                variantValue: `${data.product_variant_id}::${data.product_variant_title}`
              }
            })
          );


        /** @type {HTMLSelectElement} */ (this.tradeInForm.productBrandSelect).dispatchEvent(new CustomEvent('change', { detail: { variantValue: `${data.product_variant_id}::${data.product_variant_title}` } }));
        /** @type {HTMLSelectElement} */ (this.form.querySelector('#condition')).value = data.condition;
        for (const accessory of data.accessories) {
          /** @type {HTMLInputElement} */ (this.form.querySelector(`input[name="accessories[]"][value="${accessory}"]`)).checked = true;
        }
        /** @type {HTMLTextAreaElement} */ (this.form.querySelector('#additional-details')).value = data.additional_details;
        /** @type {HTMLInputElement} */ (this.form.querySelector('input[name="item_id"]')).value = data.item_id;
        this.tradeInForm.setAttribute('data-view', 'form+equipment');
      });
    }
  }

  render() {
    const data = /** @type {any} */ (this.formDataObject);
    this.setAttribute('data-item-id', data.item_id);
    const itemHTML = `
      <div class="trade-in-estimate-item">
        <div class="trade-in-estimate-item-info">
          <p>${data.brand} – ${data.product_variant_title}</p>
          <div>
            <span>${data.condition}</span>
            •
            <span> ${data.accessories.length} Accessories</span>
          </div>
        </div>
        <div class="trade-in-estimate-item-actions">
          <button class="trade-in-estimate-item-action-button" data-action="edit">Edit</button>
          <button class="trade-in-estimate-item-action-button" data-action="remove">Remove</button>
        </div>
      </div>
    `;
    
    this.innerHTML = itemHTML;

    this.editButton = this.querySelector('.trade-in-estimate-item-action-button[data-action="edit"]');
    this.removeButton = this.querySelector('.trade-in-estimate-item-action-button[data-action="remove"]');

    this.listeners();
  }

}

customElements.define('trade-in-estimate-item', TradeInEstimateItem);
customElements.define('trade-in-form', TradeInForm);         